module.exports = __webpack_public_path__ + "img/bk_17.f59db93a.png";